// extracted by mini-css-extract-plugin
export default {"logo":"AppLogo_logo__45RLA","text":"AppLogo_text__r0dZw"};